import { EjecutivoCementoDto } from '../../../models/ejecutivo-cemento.dto';
import { EjecutivoCementoVm } from '../../../models/ejecutivo-cemento.vm';

export class EjecutivoCementoMapper {
  static toVm(dto: EjecutivoCementoDto): EjecutivoCementoVm {
    return {
      id: Number(dto.id),
      nombre: String(dto.nombre ?? ''),
      correo: String(dto.correo ?? ''),
      telefono: String(dto.telefono ?? ''),
      regionId: Number(dto.regionId),
      regionCode: String(dto.regionCode ?? ''),
      regionName: String(dto.regionName ?? ''),
      comunaIds: Array.isArray(dto.comunaIds) ? dto.comunaIds.map(Number) : [],
      comunas: Array.isArray(dto.comunas)
        ? dto.comunas.map((comuna) => ({
            id: Number(comuna.id),
            codigo: String(comuna.codigo ?? ''),
            nombre: String(comuna.nombre ?? ''),
            regionCode: String(dto.regionCode ?? ''),
          }))
        : [],
      activo: Boolean(dto.activo),
      trackId: `ejecutivo-${dto.id}`,
    };
  }

  static toVmList(items: EjecutivoCementoDto[]): EjecutivoCementoVm[] {
    return items.map((item) => this.toVm(item));
  }
}
